/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_4_1Inputs */



/**
* | output |
* | --- |
* | "Misconfiguration of regex templates by the customer" |
*
* @param {Guardrails_Section_4_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_4_1 = /** @type {((inputs?: Guardrails_Section_4_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_4_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlkonfiguration der Regex-Templates durch den Kunden")
	return /** @type {LocalizedString} */ ("Misconfiguration of regex templates by the customer")
});